import styled from 'styled-components';

import {
  Text, defaultBoxShadow, bounceUpAnimation
} from '@comicrelief/component-library';

const Container = styled.div`
  text-align: center;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.color('grey_light')};
  padding: ${({ paddingTop, paddingBottom }) => `${paddingTop} 0 ${paddingBottom}`};

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    width: 100%;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
`;

const Category = styled.div`
  // Maintain space between multiple categories in any one List:
  padding-bottom: 4rem;
  &:last-child {
    padding-bottom: 0;
  }
`;

const List = styled.ul`
  margin: 32px auto 0;
  padding: 0 1rem;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  list-style: none;
  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: 0 2rem;
    grid-template-columns: repeat(4, 1fr);
  }
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    gap: 2rem;
  }
`;

const ListItem = styled.li`
  && a span {
    font-weight: bold;
    font-size: 1rem;

    @media ${({ theme }) => theme.allBreakpoints('L')} {
      font-size: 1.125rem;
    }
  }

  a {
    border-radius: 1rem;
    overflow: hidden;
    ${defaultBoxShadow()}

    @media ${({ theme }) => theme.allBreakpoints('M')} {
      ${bounceUpAnimation(true, 10, 1)}
      transition: transform 0.4s cubic-bezier(0.68, -1.15, 0.265, 2.35);

      &:hover {
        ${defaultBoxShadow(true)}
      }
    }
  }
`;

const GroupTitle = styled(Text)`
  margin-inline: 1rem;
`;

export {
  Container, Content, Category, List, ListItem, GroupTitle
};
